import {
  JOB_TYPE_SUPRA_LOCK_INSTALL,
  JOB_TYPE_SUNLOCK_INSTALL,
  JOB_TYPE_COMBO_LOCK_INSTALL,
  JOB_TYPE_CODEBOX_INSTALL,
  JOB_TYPE_YARD_SIGN_SETUP,
  JOB_TYPE_MEDIA,
  JOB_TYPE_MEDIA_3D_TOUR,
  JOB_TYPE_CONDITION_REPORT,
  JOB_TYPE_CONFIRM_LISTING_INFORMATION,
} from 'common/jobConstants';

import { LISTING_OCCUPANT_TYPE_VACANT } from 'common/listingConstants';

import { isPreLeaseActive } from 'common/preLeaseHelpers';

import { PROPERTY_SETUP_ACCESS_TYPE_COMBO_LOCKBOX } from 'common/marketingPartnerListingConstants';

import { isListingSunRise, isListingFullService } from 'common/listingHelpers';

import { PARTNER_ID_STONE_OAK } from 'common/partnerConstants';

export function isRequireSupra({ listing, partner }) {
  if (!isListingFullService(listing)) {
    return false;
  }

  if (partner.id === PARTNER_ID_STONE_OAK) {
    return true;
  }

  if (!partner.postToMls) {
    return false;
  }

  return (
    (listing.occupantType !== LISTING_OCCUPANT_TYPE_VACANT || !listing.requireSunlock) &&
    partner?.experienceConfiguration?.installSupraLock
  );
}

export function getRequiredMarketingPartnerListingJobs({
  listing,
  preLease,
  partner,
  marketingPartnerListing,
  isPreleaseCompletion,
}) {
  const isFullService = isListingFullService(listing);
  const isActivePreLease = preLease && isPreLeaseActive({ preLease });
  const isSunRiseService = isListingSunRise(listing);

  const requiredMarketingPartnerListingJobs = [
    JOB_TYPE_SUNLOCK_INSTALL,
    JOB_TYPE_SUPRA_LOCK_INSTALL,
    JOB_TYPE_YARD_SIGN_SETUP,
    JOB_TYPE_CODEBOX_INSTALL,
    JOB_TYPE_CONDITION_REPORT,
    JOB_TYPE_MEDIA,
    JOB_TYPE_MEDIA_3D_TOUR,
    JOB_TYPE_CONFIRM_LISTING_INFORMATION,
  ].filter((jobTypeId) => {
    let isJobRequired = null;

    switch (jobTypeId) {
      case JOB_TYPE_SUNLOCK_INSTALL:
        isJobRequired =
          marketingPartnerListing.requireSunlock &&
          listing.occupantType === LISTING_OCCUPANT_TYPE_VACANT;
        break;

      case JOB_TYPE_SUPRA_LOCK_INSTALL:
        isJobRequired =
          isRequireSupra({ listing, partner }) && (!isActivePreLease || isPreleaseCompletion);
        break;

      case JOB_TYPE_YARD_SIGN_SETUP:
        isJobRequired = marketingPartnerListing.yardSignAllowed;
        break;

      case JOB_TYPE_CODEBOX_INSTALL:
        isJobRequired = marketingPartnerListing.requireSelfShowingHardware;
        break;

      case JOB_TYPE_CONDITION_REPORT:
        isJobRequired = marketingPartnerListing.requirePropertyConditionReport;
        break;

      case JOB_TYPE_MEDIA:
        isJobRequired = marketingPartnerListing.requirePhotos;
        break;

      case JOB_TYPE_MEDIA_3D_TOUR:
        isJobRequired = marketingPartnerListing.requireVirtual3dTour;
        break;

      case JOB_TYPE_CONFIRM_LISTING_INFORMATION: {
        isJobRequired =
          (listing.occupantType === LISTING_OCCUPANT_TYPE_VACANT ||
            marketingPartnerListing.requirePhotos ||
            marketingPartnerListing.requireVirtual3dTour) &&
          (!isActivePreLease || isPreleaseCompletion) &&
          !isSunRiseService;
        break;
      }
    }

    return isJobRequired;
  });

  if (
    partner.propertySetupInstallComboLockbox &&
    listing.propertySetupAccessType !== PROPERTY_SETUP_ACCESS_TYPE_COMBO_LOCKBOX &&
    isFullService &&
    !isActivePreLease
  ) {
    requiredMarketingPartnerListingJobs.push(JOB_TYPE_COMBO_LOCK_INSTALL);
  }

  return requiredMarketingPartnerListingJobs;
}
